import { render, staticRenderFns } from "./RepXproducto.vue?vue&type=template&id=1307da98&scoped=true&"
import script from "./RepXproducto.vue?vue&type=script&scoped=true&lang=js&"
export * from "./RepXproducto.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./RepXproducto.vue?vue&type=style&index=0&id=1307da98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1307da98",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCardTitle,VCol,VDataTable,VIcon,VRow,VSelect,VSnackbar,VTextField})
